<template>
  <div class="">
    <div
      v-if="loadingDetails"
      class="loading"
    >
      <a-spin tip="loading" />
    </div>
    <div
      v-else
      class="account-info-box"
    >
      <div
        v-if="!$isDingDing"
        class="row"
      >
        <div class="row-label">
          {{ $t('message["200"]') }}：
        </div>
        <div class="row-cell">
          <span v-if="user.username">{{ user.username }}</span>
          <span v-else><router-link :to="{name: 'PersonAcount'}"> {{ $t('message["1015"]') }}</router-link>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="row-label">
          {{ $t('message["665"]') }}：
        </div>
        <div class="row-cell">
          <span v-if="!isTruenameEdit">
            {{ user.truename }}
            <a
              href="javascript:;"
              class="ml-16"
              @click="eidtTruename"
            > {{ $t('message["1388"]') }}</a>
          </span>
          <template v-if="user.truename && isTruenameEdit">
            <edit-truename
              :truername="user.truename"
              @saveEdit="saveEditTrue"
              @resetEdit="resetEdit"
            />
          </template>
        </div>
      </div>
      <div
        v-if="!$isDingDing"
        class="row"
      >
        <div class="row-label">
          {{ $t('message["198"]') }}：
        </div>
        <div class="row-cell">
          <span v-if="user.password">•••••••• <router-link
            to="/account/modifypwd"
            class="ml-16"
          >  {{ $t('message["1388"]') }}</router-link> </span>
          <span v-else><router-link :to="{name: 'PersonAcount'}">{{ $t('message["1028"]') }}</router-link></span>
        </div>
      </div>
      <div
        v-if="!$isDingDing"
        class="row"
      >
        <div class="row-label">
          {{ $t('message["1116"]') }}：
        </div>
        <div class="row-cell">
          <span v-if="user.mobile">{{ user.mobile }}  <router-link
            to="/account/modifyphone"
            class="ml-16"
          >  {{ $t('message["1388"]') }}</router-link></span>
          <span v-else><router-link :to="{name: 'PersonPhone'}"> {{ $t('message["18"]') }}</router-link></span>
        </div>
      </div>
      <div
        v-if="!$isDingDing"
        class="row"
      >
        <div class="row-label">
          {{ $t('message["1505"]') }}：
        </div>
        <div class="row-cell">
          <span v-if="user.email">{{ user.email }}  <router-link
            to="/account/modifyemail"
            class="ml-16"
          >  {{ $t('message["1388"]') }}</router-link> </span>
          <span v-else><router-link :to="{name: 'SetEmail'}"> {{ $t('message["19"]') }}</router-link></span>
        </div>
      </div>
      <qw-dd-gc />
    </div>
  </div>
</template>
<script>
import EditTruename from './EditTruename'
import QwDdGc from './QwDdGc'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    EditTruename,
    QwDdGc
  },
  data () {
    return {
      isTruenameEdit: false
    }
  },
  computed: {
    ...mapState('account/accountInfo', ['loadingDetails', 'accountDetail']),
    user () {
      const { accountDetail = {} } = this
      const { group = {} } = accountDetail
      const groups = []
      for (let i in group) {
        groups.push(group[i])
      }
      accountDetail.groups = groups.join(' ')
      return accountDetail
    }
  },
  async mounted () {
    const chain = await this.fetchAccountInfoDatas()
    chain.fetch()
  },
  methods: {
    ...mapActions('account/accountInfo', ['fetchAccountInfoDatas']),
    eidtTruename () {
      this.isTruenameEdit = true
    },
    saveEditTrue (name) {
      this.user.truename = name
      this.isTruenameEdit = false
    },
    resetEdit () {
      this.isTruenameEdit = false
    }
  }
}
</script>

<style lang="scss" scoped>
.account-info-box::v-deep {
  padding: 28px;
  .row:after {
        clear: both;
        content: '.';
        display: block;
        height: 0;
        visibility: hidden;
      }
      .row {
        padding-left: 106px;
        margin-bottom: 24px;
        .row-label {
          float: left;
          width: 96px;
          margin-left: -106px;
          color: #666;
          text-align: right;
        }
        .row-cell {
          float: left;
          width: 100%;
          .company-name {
            color: #b3b3b3;
          }
        }
      }
}
</style>
